import { SCENE_URL } from "@/config";
import { PopinMark } from "@/components/popin-mark";
import { SceneFrame } from "./scene-frame";

/**
 * Dev-only harness page for the living-scene panel (`/dev/scene`, mounted behind
 * the `SCENE_ENABLED` flag — see src/router.tsx). It intentionally lives OUTSIDE
 * the authed portal shell and makes no nav/menu change: it's the drive-through for
 * the Surface Protocol first implementation while the product placement of the
 * creation surface (menu IA) is still an open call. In-product, `SceneFrame` mounts
 * inside the portal panel; here it stands alone so it can be exercised headlessly.
 */
export function ScenePage() {
  return (
    <div className="min-h-dvh bg-background text-foreground">
      <div className="mx-auto max-w-[720px] px-6 py-10">
        <header className="mb-8 flex items-baseline gap-3">
          <PopinMark size={22} />
          <div>
            <div className="text-[15px] font-bold tracking-[.02em]">SCENE — dev preview</div>
            <div className="text-[12px] text-muted-foreground">
              Surface Protocol · dev harness · framing{" "}
              <code className="text-foreground">{SCENE_URL}</code>
            </div>
          </div>
        </header>

        <SceneFrame />
      </div>
    </div>
  );
}
